import React from 'react'
import Table from '@/components/table/Table'
import Row from '@/components/table/Row'
import PopupDialog from '@/components/popupDialog/PopupDialog'
import DownloadButton from '@/components/buttons/DownloadButton'
import {
  useLazyGetSchemaQuery,
  useLazyGetFileDownloadLinkQuery,
  IFile,
} from '@/store/apis/schemas'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

interface IState {
  selectedPopup?: 'PREVIEW_PDF'
  selectedFile?: IFile
}

const Files: React.FC = () => {
  const { t } = useTranslation()
  const urlParams = useParams()
  const [getSchemaQuery, { data: schemaData, isFetching: isGettingSchema }] =
    useLazyGetSchemaQuery()
  const [
    getFileDonwloadLinkQuery,
    { data: downloadLink, isFetching: isGettingDownloadLink },
  ] = useLazyGetFileDownloadLinkQuery()
  const [state, setState] = React.useState<IState>({})
  const schemaId = Number(urlParams.schemaId)

  React.useEffect(() => {
    getSchemaQuery({ id: schemaId })
  }, [getSchemaQuery, schemaId])

  const { selectedPopup, selectedFile } = state

  return (
    <>
      <Table
        headerLabels={[t('headers.name')]}
        isLoading={isGettingSchema}
        noButtons
      >
        {schemaData?.schema.files.map((file, index) => (
          <Row
            key={index}
            columns={{
              normal: [file.name],
            }}
            onClick={() => {
              getFileDonwloadLinkQuery({
                id: schemaId,
                path: `files/${file.name}`,
              })
              setState({
                ...state,
                selectedPopup: 'PREVIEW_PDF',
                selectedFile: file,
              })
            }}
          />
        ))}
      </Table>
      {selectedFile && (
        <PopupDialog
          isOpen={selectedPopup === 'PREVIEW_PDF'}
          title={
            <>
              {t('popups.previewFile')}: <b>{selectedFile.name}</b>
            </>
          }
          content={
            <>
              <iframe src={downloadLink?.link} width="100%" height="100%" />
            </>
          }
          fullScreen
          disableMaxWidth
          isLoading={isGettingDownloadLink}
          confirmButton={
            <DownloadButton
              downloadLink={downloadLink?.link}
              isLoading={isGettingDownloadLink}
            />
          }
          onClose={() =>
            setState({
              ...state,
              selectedPopup: undefined,
              selectedFile: undefined,
            })
          }
        />
      )}
    </>
  )
}

export default Files
